import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
const cookie = Cookies.get("user") || null;
let userData = "";
if (cookie) {
  userData = JSON.parse(cookie);
}
export const buyerFilterSlice = createSlice({
  name: "buyerFiltersReducer",
  initialState: {
    currentPage: 1,
    filters: {
      name: "",
      buyerType: "",
      addressState: "",
      favouritesOnly: false,
      userId: userData?.UserId,
      startdate: "",
      enddate: "",
      generatedBy: "",
    },
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setReduxFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const { setCurrentPage, setReduxFilters } = buyerFilterSlice.actions;
export default buyerFilterSlice.reducer;
